/**
 * Checks whether a user has a permission, supporting multi-level wildcard matching.
 * Mirrors the auth-service implementation in src/middleware/auth.ts.
 *
 * @param userPermissions - Array of permissions the user holds
 * @param required - The specific permission to check
 * @returns true if the user holds the required permission or a wildcard that covers it
 */
export function hasPermission(userPermissions: string[], required: string): boolean {
  return userPermissions.some((permission) => {
    if (permission === '*') return true;
    if (permission === required) return true;
    if (permission.endsWith(':*')) {
      const prefix = permission.slice(0, -1);
      return required.startsWith(prefix);
    }
    return false;
  });
}
